import { lazy } from 'react';

import { FontAwesome } from '~/components/Icon';

import { getRoutesArray } from './manager';

const HomePage = lazy(() => import('~/domains/home/HomePage'));
const CompanyPage = lazy(() => import('~/domains/company/CompanyPage'));
const CompanyCreatePage = lazy(() => import('~/domains/company/CompanyCreatePage'));
const CompanyManagementPage = lazy(() => import('~domains/company/CompanyManagementPage'));
const CompanyGroupPage = lazy(() => import('~/domains/company-group/CompanyGroupPage'));
const CompanyGroupCreateUpdatePage = lazy(() => import('~/domains/company-group/CompanyGroupCreateUpdatePage'));
const UsersPage = lazy(() => import('~/domains/users/UsersPage'));
const UsersCreateUpdatePage = lazy(() => import('~/domains/users/UsersCreateUpdatePage'));
const AdminPage = lazy(() => import('~/domains/administrators/AdminPage'));
const ChangelogPage = lazy(() => import('~/domains/changelog/ChangelogPage'));
const AdminCreateUpdatePage = lazy(() => import('~/domains/administrators/AdminCreateUpdatePage'));
const BrazilianOccupationCodePage = lazy(
    () => import('~/domains/brazilian-occupation-code/BrazilianOccupationCodePage'),
);
const BrazilianOccupationCodeCreateUpdatePage = lazy(
    () => import('~/domains/brazilian-occupation-code/BrazilianOccupationCodeCreateUpdatePage'),
);
const PlanPage = lazy(() => import('~/domains/plans/PlanPage'));
const PlanCreateUpdatePage = lazy(() => import('~/domains/plans/PlanCreateUpdatePage'));
const ProfilePage = lazy(() => import('~/domains/profile/ProfilePage'));
const SignaturesPage = lazy(() => import('~/domains/signatures/SignaturesPage'));
const SignatureViewPage = lazy(() => import('~/domains/signatures/SignatureViewPage'));
const OrdersPage = lazy(() => import('~/domains/orders/OrdersPage'));
const OrderViewPage = lazy(() => import('~/domains/orders/OrderViewPage'));

const GROUP_CREATE_USERS = [
    {
        group: 'Cadastro de Usuários',
        icon: {
            family: FontAwesome,
            name: 'user-plus',
        },
        routes: [
            {
                exact: true,
                path: '/usuarios',
                menuKey: '/usuarios',
                component: UsersPage,
                text: 'Usuários',
                icon: {
                    family: FontAwesome,
                    name: 'user-friends',
                },
            },
            {
                path: '/usuarios/novo',
                menuKey: '/usuarios',
                component: UsersCreateUpdatePage,
            },
            {
                path: '/usuarios/:userId',
                menuKey: '/usuarios',
                component: UsersCreateUpdatePage,
            },
            {
                exact: true,
                path: '/administradores',
                menuKey: '/administradores',
                component: AdminPage,
                text: 'Administradores',
                icon: {
                    family: FontAwesome,
                    name: 'user-tie',
                },
                permissions: [
                    {
                        can: 'read',
                        an: 'Administrador',
                    },
                ],

            },
            {
                path: '/administradores/novo',
                menuKey: '/administradores',
                component: AdminCreateUpdatePage,
                permissions: [
                    {
                        can: 'create',
                        an: 'Administrador',
                    },
                ],

            },
            {
                path: '/administradores/:adminId',
                menuKey: '/administradores',
                component: AdminCreateUpdatePage,
                permissions: [
                    {
                        can: 'update',
                        an: 'Administrador',
                    },
                ],

            },
        ],
    },
];

const GROUP_CREATE_CLIENTS = [
    {
        group: 'Cadastro de Empresas',
        icon: {
            family: FontAwesome,
            name: 'user-plus',
        },
        routes: [
            {
                exact: true,
                path: '/empresas',
                menuKey: '/empresas',
                component: CompanyPage,
                text: 'Empresas',
                icon: {
                    family: FontAwesome,
                    name: 'user-friends',
                },
            },
            {
                path: '/empresas/novo',
                menuKey: '/empresas',
                component: CompanyCreatePage,
            },
            {
                path: '/empresas/:companyId/visualizar',
                menuKey: '/empresas',
                component: CompanyManagementPage,
            },
            {
                exact: true,
                path: '/grupos-empresas',
                menuKey: '/grupos-empresas',
                component: CompanyGroupPage,
                text: 'Grupos de Empresas',
                icon: {
                    family: FontAwesome,
                    name: 'Users',
                },
            },
            {
                path: '/grupos-empresas/novo',
                menuKey: '/grupos-empresas',
                component: CompanyGroupCreateUpdatePage,
            },
            {
                path: '/grupos-empresas/:customerGroupId',
                menuKey: '/grupos-empresas',
                component: CompanyGroupCreateUpdatePage,
            },
        ],
    },
];

const CBO = [
    {
        exact: true,
        path: '/codigo-ocupacao',
        menuKey: '/codigo-ocupacao',
        component: BrazilianOccupationCodePage,
        text: 'Código Brasileiro de Ocupações',
        icon: {
            family: FontAwesome,
            name: 'RegListAlt',
        },
        permissions: [
            {
                can: 'find',
                an: 'CodigoBrasileiroOcupacao',
            },
        ],
    },
    {
        path: '/codigo-ocupacao/novo',
        menuKey: '/codigo-ocupacao',
        component: BrazilianOccupationCodeCreateUpdatePage,
    },
    {
        path: '/codigo-ocupacao/:occupationCodeId',
        menuKey: '/codigo-ocupacao',
        component: BrazilianOccupationCodeCreateUpdatePage,
    },
];

const PLANS = [
    {
        exact: true,
        path: '/planos-assinaturas',
        menuKey: '/planos-assinaturas',
        component: PlanPage,
        text: 'Planos',
        icon: {
            family: FontAwesome,
            name: 'MoneyCheckAlt',
        },
    },
    {
        path: '/planos-assinaturas/novo',
        menuKey: '/planos-assinaturas',
        component: PlanCreateUpdatePage,
    },
    {
        path: '/planos-assinaturas/:planId',
        menuKey: '/planos-assinaturas',
        component: PlanCreateUpdatePage,
    },
];

const PROFILE = [
    {
        path: '/perfil',
        component: ProfilePage,
        exact: true,
    },
];

const SIGNATURES = [
    {
        exact: true,
        path: '/assinaturas',
        menuKey: '/assinaturas',
        component: SignaturesPage,
        text: 'Assinaturas',
        icon: {
            name: 'list',
        },
    },
    {
        path: '/assinaturas/:signatureId/visualizar',
        menuKey: '/assinaturas',
        component: SignatureViewPage,
    },
];

const ORDERS = [
    {
        exact: true,
        path: '/pedidos',
        menuKey: '/pedidos',
        component: OrdersPage,
        text: 'Pedidos',
        icon: {
            name: 'assignment',
        },
    },
    {
        path: '/pedidos/:orderId/visualizar',
        menuKey: '/pedidos',
        component: OrderViewPage,
    },
];

const ROUTES = [
    {
        path: '/',
        menuKey: '/',
        component: HomePage,
        text: 'Home',
        icon: {
            name: 'dashboard',
        },
        exact: true,
    },
    ...PROFILE,
    ...GROUP_CREATE_CLIENTS,
    ...GROUP_CREATE_USERS,
    ...CBO,
    ...PLANS,
    ...ORDERS,
    ...SIGNATURES,
];

if (process.env.REACT_APP_ENV !== 'production') {
    ROUTES.push({
        path: '/changelog',
        menuKey: '/changelog',
        component: ChangelogPage,
        text: 'Changelog',
        icon: { name: 'info' },
        exact: true,
    });
}

export default ROUTES;

export const allRoutes = getRoutesArray({
    group: 'root',
    routes: ROUTES,
});
